import moment from 'moment';

export default class VuelidateUtil {

	// Validators

	public static todayOrFuture(dateString: string) {
		if (dateString) {
			const enteredDate = moment.utc(dateString);
			const today = moment.utc().startOf('day');
			return enteredDate.isSameOrAfter(today);
		}
		return false;
	}

	public static objectName(name: string) {
		return !!name.match(/^[A-Za-z0-9,\-_\(\)&\s]*$/);
	}

	public static intentName(name: string) {
		return !!name.match(/^[A-Za-z0-9,\-_\(\)\s]*$/);
	}

	// Validator Settings

	public static getAllowedMaxLength(vuelidate: any, prop: string): number {
		return vuelidate[prop].$params.maxLength.max;
	}

	// Checks

	public static isRequiredInvalid(vuelidate: any, prop: string): boolean {
		return VuelidateUtil.isValidationInvalid(vuelidate, prop, 'required');
	}

	public static isMaxLengthInvalid(vuelidate: any, prop: string): boolean {
		return VuelidateUtil.isValidationInvalid(vuelidate, prop, 'maxLength');
	}

	public static isValidationInvalid(vuelidate: any, prop: string, validationType: string): boolean {
		const vuelidateForProp = vuelidate[prop];
		const validationExistsForPropertyAndIsInvalid = vuelidateForProp[validationType] === false;
		return validationExistsForPropertyAndIsInvalid && VuelidateUtil.isPropertyInvalidAndBeenTouched(vuelidateForProp);
	}

	private static isPropertyInvalidAndBeenTouched(vuelidateForProp: any): boolean {
		// Only invalid if it's been changed
		return vuelidateForProp.$invalid && vuelidateForProp.$dirty;
	}
}
